import { render, staticRenderFns } from "./metarialWebSite.vue?vue&type=template&id=58ac11a5"
import script from "./metarialWebSite.vue?vue&type=script&lang=js"
export * from "./metarialWebSite.vue?vue&type=script&lang=js"
import style0 from "./metarialWebSite.vue?vue&type=style&index=0&id=58ac11a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports